import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  ArgumentAxis, Label, CommonSeriesSettings, } from 'devextreme-react/chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';
import { Button } from 'devextreme-react/button';
import { Tooltip as TTooltip } from 'devextreme-react/tooltip';
import './Charts.scss';

export default function ESGRsg(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [reporting2Data, setReporting2Data] = useState([]);
  const [cert1Data, setCert1Data] = useState([]);
  const [cert2Data, setCert2Data] = useState([]);
  const [cert3Data, setCert3Data] = useState([]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"]==="178" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd,"company_name");
    fd = Object.keys(fd);
    setCert1Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="179" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd,"company_name");
    fd = Object.keys(fd);
    setCert2Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="180" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd,"company_name");
    fd = Object.keys(fd);
    setCert3Data(fd);

    fd = originalData.filter((e) => {return ["178", "179", "180"].includes(e["Identifier"]) && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd, "company_name")
    fd1=[]
    let ycnt = Object.keys(fd).length
    let y_companies = Object.keys(fd)
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      y: ycnt,
      companies: y_companies
    })
    fd = groupBy(originalData, "company_name")
    
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      n: Object.keys(fd).length - ycnt,
      companies: Object.keys(fd).filter((it) => !y_companies.includes(it))
    })
    setReportingData(fd1);

    fd = originalData.filter((e) => {return ["181", "182", "183", "184"].includes(e["Identifier"]) && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd, "Metrics")
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setReporting2Data(fd);

  }, [props.data, props.year, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.seriesName}: ${pointInfo.originalValue}</div><div class="tooltip-body">${pointInfo.point.data["companies"].join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText} : ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data["companies"].join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const renderContent = () => {
      return (
          <div>Companies may be certified by more than on RSG body. For this<br/>
          reason, to totals may exceed the number of reporting companies.</div>
      );
  }

  return (
    <>
    <h4>RSG and Other Initiatives in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
    </div>
    <hr className={'mb-4'}/>
    <h5>Responsibly Sourced Gas Certification</h5>
    <div className="d-flex flex-row">
      <div className="d-flex flex-column justify-content-start align-items-center total-count-container" style={{width:"33%"}}>
        <div className="d-flex flex-column justify-content-center" style={{height:"100px", width:"130px"}}>
          <img src="/cert1.png" style={{width:"100%"}} alt="Equitable Origin"/>
        </div>
        <div className="total-count-subtitle pt-2">Certified through</div>
        <div className="total-count-subtitle">Equitable Origin</div>
        <div className="total-count">{cert1Data.length}</div>
        <ul className="w-100">
        {cert1Data.map((e) => (
          <li className="total-count-item" key={"company_"+e.toLowerCase().replaceAll(" ","_")}>
          {e}
          </li>
        ))}
        </ul>
      </div>
      <div className="d-flex flex-column justify-content-start align-items-center total-count-container" style={{width:"33%"}}>
        <div className="d-flex flex-column justify-content-center" style={{height:"100px", width:"200px"}}>
          <img src="/cert2.png" style={{width:"100%"}} alt="MiQ"/>
        </div>
        <div className="total-count-subtitle pt-2">Certified through</div>
        <div className="total-count-subtitle">MiQ</div>
        <div className="total-count">{cert2Data.length}</div>
        <ul className="w-100">
        {cert2Data.map((e) => (
          <li className="total-count-item" key={"company_"+e.toLowerCase().replaceAll(" ","_")}>
          {e}
          </li>
        ))}
        </ul>
      </div>
      <div className="d-flex flex-column justify-content-start align-items-center total-count-container" style={{width:"33%"}}>
        <div className="d-flex flex-column justify-content-center" style={{height:"100px", width:"200px"}}>
          <img src="/cert3.png" style={{width:"100%"}} alt="Trustwell"/>
        </div>
        <div className="total-count-subtitle pt-2">Certified through</div>
        <div className="total-count-subtitle">Trustwell</div>
        <div className="total-count">{cert3Data.length}</div>
        <ul className="w-100">
        {cert3Data.map((e) => (
          <li className="total-count-item" key={"company_"+e.toLowerCase().replaceAll(" ","_")}>
          {e}
          </li>
        ))}
        </ul>
      </div>
    </div>
    <Chart
      id="chart"
      width="100%"
      dataSource={reportingData}
      title={"Number of AXPC Companies Pursuing RSG"}
      rotated={true}
      barGroupWidth={40}
      height={"250px"}
    >
      <ArgumentAxis visible={false}/>
      <CommonSeriesSettings
        argumentField="date"
      />
      <Series
        type="stackedbar"
        valueField={"y"}
        name={"Y"}
        ignoreEmptyPoints={true}
        color="rgba(20, 77, 109, 0.8)"
      />
      <Series
        type="stackedbar"
        valueField={"n"}
        name={"N"}
        ignoreEmptyPoints={true}
        color="rgba(236, 80, 32, 0.8)"
      />
      <ValueAxis showZero={true} />
      <Legend
        visible={true}
        rowCount={1}
        verticalAlignment="bottom"
        horizontalAlignment="center"/>
      <Tooltip
        enabled={true}
        shared={true}
        customizeTooltip={customizeTooltip}
      />
    </Chart>
    <hr className={'mb-4'}/>
    <div className="d-flex flex-column justify-content-between">
      <div className="d-flex flex-row">
        <h5>Other External Initiatives and Partnerships</h5>
        <div>
          <Button
            id="moreweight3"
            icon='fas fa-info-circle'
            stylingMode="text"
            type="normal"
          />
          <TTooltip
              target="#moreweight3"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              contentRender={renderContent}
          />
        </div>
      </div>
      <Chart
        id="chart"
        dataSource={reporting2Data}
      >
        <CommonSeriesSettings
          argumentField="name"
        >
          <Label
            wordWrap="normal"
          />
        </CommonSeriesSettings>
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="outside"
          />
        </ArgumentAxis>
        <Series
          type="bar"
          valueField="val"
          color="rgba(20, 77, 109, 0.8)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={false}
        />
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip2}
        />
      </Chart>
    </div>
    </>
  );
}
